import { useCallback, useMemo } from 'react';
import { toast } from 'sonner';

export function useToast() {
  const showToast = useCallback((message: string, type: 'success' | 'error' | 'warning' | 'info' = 'info') => {
    if (type === 'success') toast.success(message);
    else if (type === 'error') toast.error(message, { duration: 4000 });
    else if (type === 'warning') toast.warning(message, { duration: 4000 });
    else toast.info(message);
  }, []);

  return useMemo(() => ({
    showToast,
    // Backward-compatible: old code destructures { toast, showToast, hideToast }
    toast: { message: '', type: 'error' as const },
    hideToast: () => {},
  }), [showToast]);
}
